import { useSelector } from "react-redux";
import { selectCurrent } from "../../../redux/settings/selectors";
import { useEffect, useState } from "react";
import storePersist from "../../../redux/storePersist";
import { useAppDispatch } from "../../../hooks/hooks";
import _ from 'lodash'
import { getCardData } from "../../../common/services/website-card.service";
import { library } from "../../../redux/library/action";
import { countries } from "../../../redux/countries/action";
import { states } from "../../../redux/states/action";
import { settings } from "../../../redux/settings/actions";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import GoogleMapSearch from "../../../common/components/google-map-search";
import { leads } from "../../../redux/leads/action";
import { cmsSettings } from "../../../redux/cmsSettings/action";
import { useNavigate } from "react-router-dom";
import { selectOrganizationUnitsListItems } from "../../../redux/organizationUnits/selector";
import { selectLeadsCreatedItem } from "../../../redux/leads/selector";
import { toast } from "react-toastify";
import { RotatingLines } from "react-loader-spinner";
import { newsletterSubscriptions } from "../../../redux/news-letter-subscription/action";
import { quotes } from "../../../redux/quotes/action";
import { cargoLeads } from "../../../redux/cargo-lead/action";
import { logisticsConfigurations } from "../../../redux/logistics-Configurations/action";
import { dbaTypes } from "../../../redux/dba-types/action";

const slider1 = require('./../../../assets/img/slider1.png')
const slider2 = require('./../../../assets/img/slider2.png')

const LogisticHome = () => {
	const dispatch = useAppDispatch()
	let navigate = useNavigate()
	const result = useSelector(selectCurrent)
	const { tenantId, lightLogo, darkLogo } = result
	const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false)
	const [isLead, setIsLead] = useState<boolean>(false)
	const [logo, setLogo] = useState<any>()
	const organizationLists = useSelector(selectOrganizationUnitsListItems)
	const [generateIds, setGenerateIds] = useState<any>([]);
	const [leadValues, setLeadValues] = useState<any>()
	const leadCreateData = useSelector(selectLeadsCreatedItem)
	const [subscriptionData, getsubscriptionData] = useState<any>();
	const [searchedLocation, setSearchedLocation] = useState({
		name: '',
		lat: '',
		lng: '',
		pincode: '',
		description: '',
	});


	const [searchedToLocation, setSearchedToLocation] = useState({
		name: '',
		lat: '',
		lng: '',
		pincode: '',
		description: '',
	});
	const handleChange: any = (event: any, field: string) => {
		setLeadValues({ ...leadValues, [field]: event })
		getsubscriptionData({ ...subscriptionData, [field]: event })
	}

	// Deferred API
	const deferredAPICalls = async () => {
		dispatch(quotes.resetAction({ actionType: 'create' }))
		await dispatch(leads.resetAction({ actionType: 'create' }))
		await dispatch(cargoLeads.resetAction({ actionType: 'create' }))
		if (storePersist.get('guestTokenMetadata').current?.success) {
			await dispatch(library.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/library/query-by-list`, entity: 'library' }))
			await dispatch(countries.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/countrys`, entity: 'countries' }))
			await dispatch(states.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/stateprovinces`, entity: 'states' }))
			await dispatch(cmsSettings.list({ url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/cms/query`, entity: 'cmsSettings', jsonData: {} }))
			await dispatch(logisticsConfigurations.query({ url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configurations/logistics/query`, entity: 'logistics', jsonData: {} }))
			await dispatch(dbaTypes.list({ url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dba-types/list`, entity: 'dbaTypes', jsonData: {} }))
		}

	}

	useEffect(() => {
		setLogo(darkLogo || lightLogo)
	}, [result]);

	useEffect(() => {
		(async () => {
			generateIdValue()
			const input = document.getElementById("datetime") as HTMLInputElement;

			input.addEventListener("change", function () {
				const minDateTime = new Date(input.min);
				const selectedDateTime = new Date(input.value);
				if (selectedDateTime < minDateTime) {
					alert("Please select a valid time.");
					input.value = input.min; // reset to min
				}
			});
		})();
	}, []);

	const generateUniqueId = () => {
		const randomPart = Math.random().toString(36).substr(2, 9); // Random part
		const timestampPart = Date.now().toString(36); // Timestamp part
		return `${randomPart}-${timestampPart}`;
	};

	const generateIdValue = () => {
		const newItem = {
			transaction_id: generateUniqueId(),
			message_id: generateUniqueId(),
		};
		setGenerateIds(newItem);
	};



	useEffect(() => {
		(async () => {
			if (tenantId) {
				localStorage.removeItem('access-token')
				localStorage.removeItem('accessTokenMetadata')
				localStorage.removeItem('userProfile')
				deferredAPICalls();

			}
		})()
	}, [tenantId])


	const HomePageBannerData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_BANNER') : null;

	const banner = (HomePageBannerData && HomePageBannerData[0]?.src ? encodeURI(HomePageBannerData[0]?.src) : require('./../../../assets/img/logisticsBanner.png'))

	const workProcessHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_WORK_PROCESS_HEADING') : null;

	const workProcessData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_WORK_PROCESS') : null;

	const eMobilityHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_E_MOBILITY_HEADING') : null;

	const eMobilityData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_E_MOBILITY') : null;

	const serviceHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_SERVICE_HEADING') : null;

	const serviceData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_SERVICE') : null;

	const handleSubmit = async (event: any) => {

		event?.preventDefault()
		if (!leadValues?.IsExistingUser) {
			if (
				!leadValues?.Email ||
				!leadValues?.Name ||
				!leadValues?.PhoneNumber ||
				!leadValues?.date ||
				!searchedLocation?.description ||
				!searchedToLocation?.description
			) {
				toast.error("All fields are required. Please fill in all the details.");
				return;
			}
		} else {
			if (
				!leadValues?.date ||
				!leadValues?.Email ||
				!searchedLocation?.description ||
				!searchedToLocation?.description
			) {
				toast.error("All fields are required. Please fill in all the details.");
				return;
			}
		}

		// Validate phone number length
		if (!leadValues?.IsExistingUser && leadValues?.PhoneNumber?.length < 10) {
			toast.error("Please enter a valid phone number with at least 10 digits.");
			return;
		}

		// Validate email format 
		const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
		if (leadValues?.Email && !emailRegex.test(leadValues?.Email)) {
			toast.error("Please enter a valid email address.");
			return;
		}

		// Parse addresses
		const fromAddressData = _.split(searchedLocation?.description, ',');
		const toAddressData = _.split(searchedToLocation?.description, ',');
		try {
			await setIsButtonLoading(true)
			if (searchedLocation?.description !== searchedToLocation?.description) {
				await dispatch(leads.resetAction({ actionType: 'create' }))
				await dispatch(leads.create({
					url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/leads`, entity: 'leadCreate', jsonData: {
						"Records": [
							{
								Context: {
									transaction_id: generateIds?.transaction_id,
									message_id: generateIds?.message_id,
								},
								Message: {
									LeadInfo: {
										Name: leadValues?.Name,
										Email: leadValues?.Email,
										PhoneNumber: leadValues?.PhoneNumber || '',
										date: leadValues?.date,
										Description: '',
										IsExistingUser: leadValues?.IsExistingUser || false,
										LeadPayload: {
											weight: {
												unit: '',
												value: 0
											},
											dimensions: {
												length: {
													unit: '',
													value: 0
												},
												breadth: {
													unit: '',
													value: 0
												},
												height: {
													unit: '',
													value: 0
												}
											},
											category: '',
											value: {
												currency: 'INR',
												value: 0
											},
											dangerous_goods: false
										},
										start: {
											location: {
												gps: `${searchedLocation?.lat},${searchedLocation?.lng}`,
												address: {
													name: searchedLocation?.name,
													building: searchedLocation?.description,
													locality: `${fromAddressData[0]},${fromAddressData[1]}`,
													city: searchedLocation?.name,
													state: fromAddressData[3],
													country: 'India',
													area_code: searchedLocation?.pincode,
												},
											},
											contact: {
												phone: leadValues?.PhoneNumber,
												email: leadValues?.Email,
											},
										},

										end: {
											location: {
												gps: `${searchedToLocation?.lat},${searchedToLocation?.lng}`,
												address: {
													name: searchedToLocation?.name,
													building: searchedToLocation?.description,
													locality: `${toAddressData[0]},${toAddressData[1]}`,
													city: searchedToLocation?.name,
													state: toAddressData[3],
													country: 'India',
													area_code: searchedToLocation?.pincode,
												},
											},
										},
									}
								}
							}
						]
					}
				}))
				await setIsButtonLoading(false)
				await setIsLead(true)
			}

			else {
				setIsButtonLoading(false)
				toast.error("The Pickup and Drop addresses must be different.")
			}

		} catch (error) {
			toast.error("An error occurred while submitting the form. Please try again.");
		}
	}

	useEffect(() => {
		if (leadCreateData?.isSuccess && isLead) {
			dispatch(settings.set({
				quoteData: leadValues,
				searchedLocation,
				searchedToLocation,
			}))
			setSearchedLocation({
				name: '',
				lat: '',
				lng: '',
				pincode: '',
				description: '',
			});
			setSearchedToLocation({
				name: '',
				lat: '',
				lng: '',
				pincode: '',
				description: '',
			});
			setLeadValues({
				Name: '',
				Email: '',
				PhoneNumber: '',
				date: '',
				IsExistingUser: '',
			})
			setIsLead(false)
			navigate('/auth/login', {
				state:
					{ pageName: 'Parcel' }
			})
		}
	}, [isLead])

	const HTMLContent: any = ({ htmlContent }: any) => {
		return (
			<div
				dangerouslySetInnerHTML={{ __html: htmlContent }}
			/>
		);
	};

	return (

		<div className={`flex flex-col items-center justify-center w-full bg-white `} >

			{/* Banner Section */}
			<div className="flex flex-col items-center justify-center w-full " style={{
				backgroundImage: `url(${banner})`,
				backgroundSize: 'cover',
				backgroundPosition: 'center',
				backgroundRepeat: 'no-repeat'
			}}>
				<div className="flex justify-around items-end  w-full h-[620px] px-10">
					<div className="flex flex-col justify-between items-center w-1/2">
					</div>
					<div className={`w-1/3 justify-center item-center  rounded-t-2xl bg-white`}>
						<div className="w-full p-5 flex flex-col justify-center items-center rounded-2xl">
							<div className="text-2xl text-primary font-bold text-center pb-2">Instant Quote Calculator</div>
							<div className="w-full p-4">
								<div className="space-y-2">
									<div className="flex items-center space-x-2">
										<input
											type="checkbox"
											name="from"
											className="accent-primary h-4 w-4"
											onChange={(e) => handleChange(e.target.checked, 'IsExistingUser')}
											checked={leadValues?.IsExistingUser}
										/>
										<label className="text-sm text-gray-700">Are You Already Registered?</label>
									</div>

									{!leadValues?.IsExistingUser ? (
										<>
											<GoogleMapSearch
												className="w-full border-b-2 border-black ps-8  pe-10 py-2 text-base focus:outline-none"
												setLocation={setSearchedLocation}
												location={searchedLocation}
												placeholder="Pickup Address"
											/>
											<GoogleMapSearch
												className="w-full border-b-2 border-black ps-8  pe-10 py-2 text-base focus:outline-none"
												setLocation={setSearchedToLocation}
												location={searchedToLocation}
												placeholder="Drop Address"
											/>

											<div className="flex gap-4">
												<input
													required
													maxLength={10}
													pattern="\d{10}"
													type="text"
													name="PhoneNumber"
													placeholder="Phone Number"
													className="w-1/2 border-b-2 border-black py-2 px-3 text-base focus:outline-none "
													onChange={(e) => handleChange(e.target.value.replace(/\D/g, ''), 'PhoneNumber')}
													value={leadValues?.PhoneNumber}
												/>
												<input
													required
													type="email"
													name="Email"
													placeholder="Email"
													className="w-1/2 border-b-2 border-black py-2 px-3 text-base focus:outline-none"
													onChange={(e) => handleChange(e.target.value, 'Email')}
													value={leadValues?.Email}
												/>
											</div>

											<div className="flex gap-4">
												<input
													type="text"
													name="Name"
													placeholder="Full Name"
													className="w-1/2 border-b-2 border-black py-2 px-3 text-base focus:outline-none"
													onChange={(e) => handleChange(e.target.value, 'Name')}
													value={leadValues?.Name}
												/>
												<input
													required
													id="datetime"
													type="datetime-local"
													name="scheduleDate"
													min={
														new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000)
															.toISOString()
															.slice(0, 16)
													}
													onClick={(event) => {
														const input = event.target as HTMLInputElement; // Type cast to HTMLInputElement
														input.showPicker(); // Now you can call showPicker() safely
													}}
													className={`w-1/2 border-b-2 border-black py-2 px-3 text-base focus:outline-none ${!leadValues?.date ? 'text-gray-400' : 'text-sky-950'}`}
													onChange={(e) => handleChange(e.target.value, 'date')}
													value={leadValues?.date}
												/>
											</div>
										</>
									) : (
										<>
											<input
												type="text"
												name="Email"
												placeholder="Email"
												className="w-full border-b-2 border-black py-2 px-3 text-base focus:outline-none"
												onChange={(e) => handleChange(e.target.value, 'Email')}
												value={leadValues?.Email}
											/>
											<GoogleMapSearch
												className="w-full border-b-2 border-black ps-8  pe-10 py-2 text-base focus:outline-none"
												setLocation={setSearchedLocation}
												location={searchedLocation}
												placeholder="Pickup Address"
											/>
											<GoogleMapSearch
												className="w-full border-b-2 border-black ps-8  pe-10 py-2 text-base focus:outline-none"
												setLocation={setSearchedToLocation}
												location={searchedToLocation}
												placeholder="Drop Address"
											/>
											<input
												required
												id="datetime"
												type="datetime-local"
												name="scheduleDate"
												min={
													new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000)
														.toISOString()
														.slice(0, 16)
												}
												onClick={(event) => {
													const input = event.target as HTMLInputElement; // Type cast to HTMLInputElement
													input.showPicker(); // Now you can call showPicker() safely
												}}
												className={`w-full border-b-2 border-black py-2 px-3 text-base focus:outline-none ${!leadValues?.date ? 'text-gray-400' : 'text-sky-950'}`}
												onChange={(e) => handleChange(e.target.value, 'date')}
												value={leadValues?.date}
											/>
										</>
									)}
								</div>

								<button
									onClick={!isButtonLoading ? handleSubmit : undefined}
									disabled={isButtonLoading}
									className={`mt-6 w-full bg-primary text-white font-semibold py-3 rounded-md flex items-center justify-center transition-opacity duration-300 ${isButtonLoading ? 'opacity-70' : 'hover:opacity-90'}`}
								>
									Get Quote
									{isButtonLoading && (
										<div className="pl-2">
											<RotatingLines
												visible={true}
												width="20"
												strokeColor="#fff"
												strokeWidth="6"
												animationDuration="0.75"
												ariaLabel="rotating-lines-loading"
											/>
										</div>
									)}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>



			{/* Section 2 */}
			<div className="w-full flex items-center justify-center flex-col">
				<div className={`flex flex-col justify-center items-center w-full `}>
					<div className="flex flex-col justify-start pt-20 pl-14 items-start space-y-1 w-full pr-10">
						<div className="text-3xl font-bold uppercase ">
							{workProcessHeading ? workProcessHeading[0]?.title : null}
						</div>
					</div>
					<div className="flex flex-row justify-around items-stretch w-full pt-10 px-10">
						{/* Card 1 */}
						<div className="relative flex flex-col justify-center items-center w-72 px-2">
							<div className="relative overflow-hidden bg-clip-border rounded-xl h-64">
								<img src={workProcessData && workProcessData[0]?.src ? workProcessData[0]?.src : 'https://via.placeholder.com/272x256'} alt="card-image" className="object-cover w-full h-full" />
							</div>
							<div className="flex-grow p-1 font-semibold text-lg text-center">
								{workProcessData ? workProcessData[0]?.title : null}
							</div>
							<div className="flex-grow p-1 text-center text-base min-h-[60px]">
								{workProcessData ? workProcessData[0]?.subTitle : null}
							</div>
						</div>

						{/* Card 2 */}
						<div className="relative flex flex-col justify-center items-center w-72 px-2">
							<div className="relative overflow-hidden bg-clip-border rounded-xl h-64">
								<img src={workProcessData && workProcessData[1]?.src ? workProcessData[1]?.src : 'https://via.placeholder.com/272x256'} alt="card-image" className="object-cover w-full h-full" />
							</div>
							<div className="flex-grow p-1 font-semibold text-lg text-center">
								{workProcessData ? workProcessData[1]?.title : null}
							</div>
							<div className="flex-grow p-1 text-center text-base min-h-[60px]">
								{workProcessData ? workProcessData[1]?.subTitle : null}
							</div>
						</div>

						{/* Card 3 */}
						<div className="relative flex flex-col justify-center items-center w-72 px-2">
							<div className="relative overflow-hidden bg-clip-border rounded-xl h-64">
								<img src={workProcessData && workProcessData[2]?.src ? workProcessData[2]?.src : 'https://via.placeholder.com/272x256'} alt="card-image" className="object-cover w-full h-full" />
							</div>
							<div className="flex-grow p-1 font-semibold text-lg text-center">
								{workProcessData ? workProcessData[2]?.title : null}
							</div>
							<div className="flex-grow p-1 text-center text-base min-h-[60px]">
								{workProcessData ? workProcessData[2]?.subTitle : null}
							</div>
						</div>

						{/* Card 4 */}
						<div className="relative flex flex-col justify-center items-center w-72 px-2">
							<div className="relative overflow-hidden bg-clip-border rounded-xl h-64">
								<img src={workProcessData && workProcessData[3]?.src ? workProcessData[3]?.src : 'https://via.placeholder.com/272x256'} alt="card-image" className="object-cover w-full h-full" />
							</div>
							<div className="flex-grow p-1 font-semibold text-lg text-center">
								{workProcessData ? workProcessData[3]?.title : null}
							</div>
							<div className="flex-grow p-1 text-center text-base min-h-[60px]">
								{workProcessData ? workProcessData[3]?.subTitle : null}
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Section 3 */}
			<div className="w-full flex items-center justify-center flex-col">
				<div className={`flex flex-col justify-center items-center w-full`}>
					<div className="flex flex-col justify-start pt-20 pl-14 items-start space-y-1 w-full pr-10">
						<div className="text-3xl font-bold uppercase">
							{eMobilityHeading ? eMobilityHeading[0]?.title : null}
						</div>
					</div>
					<div className="flex flex-row justify-around items-stretch w-full my-10 mx-10 ">
						{/* Card 1 */}
						<div className={`relative flex flex-col justify-center items-center rounded-xl h-72 w-72 px-2 bg-primary `}>
							<div className="relative overflow-hidden bg-clip-border rounded-xl pt-14">
								<HTMLContent htmlContent={eMobilityData ? eMobilityData[0]?.description : ''} />
							</div>
							<div className="flex-grow pt-4 font-semibold text-3xl text-light">
								{eMobilityData ? eMobilityData[0]?.title : null}
							</div>
							{/* <div className="flex-grow p-1 text-center text-xs min-h-[60px]">
                    {promiseContentData ? promiseContentData[0]?.subTitle : null}
                </div> */}
						</div>

						{/* Card 2 */}
						<div className={`relative flex flex-col justify-center items-center rounded-xl h-72 w-72 px-2 bg-primary `}>
							<div className="relative overflow-hidden bg-clip-border rounded-xl pt-14">
								<HTMLContent htmlContent={eMobilityData ? eMobilityData[1]?.description : ''} />
							</div>
							<div className="flex-grow pt-4 font-semibold text-3xl text-light">
								{eMobilityData ? eMobilityData[1]?.title : null}
							</div>
							{/* <div className="flex-grow p-1 text-center text-xs min-h-[60px]">
                    {promiseContentData ? promiseContentData[1]?.subTitle : null}
                </div> */}
						</div>

						{/* Card 3 */}
						<div className={`relative flex flex-col justify-center items-center rounded-xl h-72 w-72 px-2 bg-primary`}>
							<div className="relative overflow-hidden bg-clip-border rounded-xl pt-14">
								<HTMLContent htmlContent={eMobilityData ? eMobilityData[2]?.description : ''} />
							</div>
							<div className="flex-grow pt-4 font-semibold text-3xl text-light">
								{eMobilityData ? eMobilityData[2]?.title : null}
							</div>
							{/* <div className="flex-grow p-1 text-center text-xs min-h-[60px]">
                    {promiseContentData ? promiseContentData[2]?.subTitle : null}
                </div> */}
						</div>

						{/* Card 4 */}
						<div className={`relative flex flex-col justify-center items-center rounded-xl h-72 w-72 px-2 bg-primary `}>
							<div className="relative overflow-hidden bg-clip-border pt-14">
								<HTMLContent htmlContent={eMobilityData ? eMobilityData[3]?.description : ''} />
							</div>
							<div className="flex-grow pt-4 font-semibold text-3xl text-light">
								{eMobilityData ? eMobilityData[3]?.title : null}
							</div>
							{/* <div className="flex-grow p-1 text-center text-xs min-h-[60px]">
                    {promiseContentData ? promiseContentData[3]?.subTitle : null}
                </div> */}
						</div>
					</div>
				</div>
			</div>

			{/* Section 4 */}
			<div className="w-full flex items-center justify-center flex-col">
				<div className={`flex flex-col justify-center items-center w-full `}>
					<div className="flex flex-col justify-start pt-20 pl-14 items-start space-y-1 w-full pr-10">
						<div className="text-3xl font-bold uppercase">
							{serviceHeading ? serviceHeading[0]?.title : null}
						</div>
					</div>
					<div className="flex flex-row justify-around items-stretch w-full my-10 mx-5 px-20">
						{/* Card 1 */}
						<div className="relative flex flex-col justify-center items-center w-80 ">
							<div className="relative overflow-hidden bg-clip-border rounded-xl h-40">
								{/* <svg height="150" width="150" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#233c64" transform="matrix(-1, 0, 0, 1, 0, 0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <style type="text/css"> </style> <g> <path d="M447.77,33.653c-36.385-5.566-70.629,15.824-82.588,49.228h-44.038v37.899h40.902 c5.212,31.372,29.694,57.355,62.855,62.436c41.278,6.316,79.882-22.042,86.222-63.341C517.428,78.575,489.07,39.969,447.77,33.653z "></path> <path d="M162.615,338.222c0-6.88-5.577-12.468-12.468-12.468H96.16c-6.891,0-12.467,5.588-12.467,12.468 c0,6.868,5.576,12.467,12.467,12.467h53.988C157.038,350.689,162.615,345.091,162.615,338.222z"></path> <path d="M392.999,237.965L284.273,340.452l-37.966,9.398v-86.619H0v215.996h246.307v-59.454l35.547-5.732 c16.95-2.418,29.396-6.692,44.336-15.018l46.302-24.228v104.432h132.435V270.828C504.927,202.618,428.016,202.43,392.999,237.965z M215.996,448.913H30.313v-155.37h185.683v63.805l-36.419,9.01c-15.968,4.395-25.708,20.518-22.174,36.696l0.298,1.247 c3.478,15.912,18.651,26.436,34.785,24.14l23.51-3.788V448.913z"></path> </g> </g></svg> */}
								<HTMLContent htmlContent={serviceData ? serviceData[0]?.description : ''} />
							</div>
							<div className="flex-grow p-1 font-semibold text-lg text-center">
								{serviceData ? serviceData[0]?.title : null}
							</div>
							<div className="flex-grow p-1 text-center text-base min-h-[60px]">
								{serviceData ? serviceData[0]?.subTitle : null}
							</div>
						</div>
						<div className=" h-40 mt-10 border-r-2 border-gray-500"></div>
						{/* Card 2 */}
						<div className="relative flex flex-col justify-center items-center w-80 ">

							<div className="relative overflow-hidden bg-clip-border rounded-xl h-40">
								<HTMLContent htmlContent={serviceData ? serviceData[1]?.description : ''} />
							</div>
							<div className="flex-grow p-1 font-semibold text-lg text-center">
								{serviceData ? serviceData[1]?.title : null}
							</div>
							<div className="flex-grow p-1 text-center text-base min-h-[60px]">
								{serviceData ? serviceData[1]?.subTitle : null}
							</div>

						</div>
						<div className=" h-40 mt-10 border-r-2 border-gray-500"></div>
						{/* Card 3 */}
						<div className="relative flex flex-col justify-center items-center w-80 ">
							<div className="relative overflow-hidden bg-clip-border rounded-xl h-40">
								<HTMLContent htmlContent={serviceData ? serviceData[2]?.description : ''} />
							</div>
							<div className="flex-grow p-1 font-semibold text-lg text-center">
								{serviceData ? serviceData[2]?.title : null}
							</div>
							<div className="flex-grow p-1 text-center text-base min-h-[60px]">
								{serviceData ? serviceData[2]?.subTitle : null}
							</div>
						</div>



					</div>
				</div>
			</div>
			{/* <div className={`w-full flex flex-row items-center h-64 px-10 secondary-${color}  border-y border-black border-opacity-20`}>
								<div className="flex flex-col w-1/2 text-md m-4 p-4">
									<div className="text-2xl font-bold py-3 uppercase ">{partnerConentData ? partnerConentData[0]?.title : null}</div>
									<div className="text-md  text-justify">{partnerConentData ? partnerConentData[0]?.description : null}
									</div>
								</div>
								<div className="flex w-1/2">
									{partnerConentData && partnerConentData[0]?.src ? <img src={partnerConentData[0]?.src} width="600" height="300" />
										: <img src={'https://via.placeholder.com/1000x337'} width="600" height="300" />}

								</div>
							</div> */}

		</div >
	)
}

export default LogisticHome
